import { Container } from '@mui/material';
import Page from '../../../components/Page';
import PropertySubCategoryForm from './PropertySubCategoryForm';

const index = () => {
  return (
    <Page title={'Property Sub Category'}>
      <Container maxWidth={'xl'}>
        <PropertySubCategoryForm />
      </Container>
    </Page>
  );
};

export default index;
